/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as PDFIcon } from "icons/pdf.svg";
import { ReactComponent as WordIcon } from "icons/word.svg";
import { ReactComponent as ExcelIcon } from "icons/excel.svg";
import { TooltipTrigger } from "@visiblethread/react-components/dist/components/Tooltip";
import info from "../../icons/info.svg";

const Documents = ({ documents }) => {
  const determineIcon = (type) => {
    switch (type) {
      case "pdf":
        return <PDFIcon />;
      case "word":
        return <WordIcon />;
      case "excel":
      default:
        return <ExcelIcon />;
    }
  };

  function getNoWordsOverlay(fileType) {
    return (
      <TooltipTrigger content={`This ${fileType} file contains no words`}>
        <img src={info} alt="info" style={{ height: "18px" }} />
      </TooltipTrigger>
    );
  }

  return (
    <div className="documents_component" data-testid="documents-component">
      {documents.map((document, index) => {
        let t =
          document.type.substring(0, 1).toUpperCase() +
          document.type.substring(1);
        if (document.type === "pdf") {
          t = "PDF";
        }
        const handleClick = () => {
          window.Application.common.drillInto(
            0,
            window.PageObject.docSetId,
            document.docId
          );
        };
        return (
          <div
            className={`documents_component__document ${
              index !== documents.length - 1 ? "divider" : ""
            }`}
          >
            <span
              className={`documents_component__document__icon ${document.type}`}
            >
              {determineIcon(document.type)}
            </span>
            <span className="documents_component__document__heading">
              <span
                className="documents_component__document__heading__title"
                onClick={handleClick}
              >
                {document.docName}
              </span>
              <span className="documents_component__document__heading__description">
                Added {document.creationDate} by {document.username}
              </span>
            </span>
            <span className="documents_component__document__message">
              {parseInt(document.detailedSize, 10) === 0 &&
                getNoWordsOverlay(t)}
            </span>
            <span className="documents_component__document__language">
              {document.languageDetected}
            </span>
            <span className="documents_component__document__detail">
              <span
                className={`documents_component__document__detail__words
                ${
                  parseInt(document.detailedSize, 10) === 0 ? "highlight" : ""
                }`}
              >
                {document.detailedSize} {document.detailedSizeUnit}
              </span>
              <span className="documents_component__document__detail__size">
                {document.fileSize}
              </span>
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default Documents;

Documents.propTypes = {
  documents: PropTypes.oneOfType([PropTypes.array]).isRequired,
};
